"use client";
import { ControlHint as e } from "../controls/ControlHint.js";
import { isPointerMenuEvent as t } from "./menu-motion.js";
import { MenuContent as n } from "./MenuContent.js";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { useId as a, useState as o } from "react";
import { Menu as s } from "@base-ui/react/menu";
//#region src/components/dropdown/Dropdown.tsx
var c = ({ menu: c, trigger: l, disabled: u = !1, disabledReason: d, open: f, defaultOpen: p, onOpenChange: m, ...h }) => {
	let g = a(), [_, v] = o(!1), y = u ? d : void 0;
	return /* @__PURE__ */ i(s.Root, {
		open: f,
		defaultOpen: p,
		disabled: u,
		onOpenChange: (e, n) => {
			v(t(n.event)), m?.(e);
		},
		children: [
			/* @__PURE__ */ r(e, {
				label: y,
				children: /* @__PURE__ */ r(s.Trigger, {
					render: l,
					disabled: u,
					"aria-describedby": y ? g : void 0
				})
			}),
			y && /* @__PURE__ */ r("span", {
				className: "pf-control-sr pf:sr-only",
				id: g,
				children: y
			}),
			/* @__PURE__ */ r(n, {
				animate: _,
				menu: c,
				...h
			})
		]
	});
};
//#endregion
export { c as Dropdown };
